module.exports = __webpack_public_path__ + "img/DE03824.18b1526d.png";